import Handlebars from 'handlebars';

export const getValueByPath = (obj: any, path: string) => {
  if (!obj || !path) return undefined;
  const parts = path.split('.');
  let cur = obj;
  for (const p of parts) {
    if (cur === undefined || cur === null) return undefined;
    cur = cur[p];
  }
  return cur;
};

/**
 * Fills `{{field_name}}` placeholders from `dataObj` with Handlebars, falling
 * back to a plain path lookup when the text is not a valid template.
 */
export const fillTemplate = (template: string, dataObj: any): string => {
  if (!template) return template;
  try {
    const out = Handlebars.compile(String(template))(dataObj || {});
    return out === undefined || out === null ? '' : String(out);
  } catch (e) {
    return template.replace(/\{\{\s*([^}]+?)\s*\}\}/g, (_, key: string) => {
      const val = getValueByPath(dataObj, key.trim());
      return val === undefined || val === null ? '' : String(val);
    });
  }
};
